import { Modal } from "react-bootstrap"
import { useState } from "react"

import Countries from "../../../Avatar/AvatarSurvey/Survey/templates/Countries"
import States from "../../../Avatar/AvatarSurvey/Survey/templates/States"
import callAPI from "../../../../helpers/callAPI"

const WhitelistAddressModal = ({ isOpen, setIsOpen, showSystemMessage, refetch }) => {

    const [country, setCountry] = useState('')
    const [state, setState] = useState('')

    const createBlacklist = async (e) => {
        e.preventDefault()

        let data = {
            street_address_1: e.target.street_address_1.value,
            street_address_2: e.target.street_address_2.value,
            city: e.target.city.value,
            state: (country === 'US' || country === 'CA') ? state : e.target.state.value,
            country_code: country,
            zip_code: e.target.zip_code.value,
            payment_platform: e.target.payment_platform.value,
            purpose: e.target.purpose.value
        }

        callAPI('compliance/whitelist', 'POST', data)
            .then(result => {
                if (result['success'] === true) {
                    showSystemMessage('success', result.message)
                    setIsOpen(false)
                    refetch()
                } else {
                    showSystemMessage('error', result.errors.message)
                }
            }).catch(error => {
                console.log(`Error while creating whitelist address: ${error}`)
                showSystemMessage('error', 'An error occurred while creating whitelist address.')
            })

    }

    return (
        <Modal show={isOpen} onHide={() => setIsOpen(false)}>
            <form onSubmit={createBlacklist}>
                <Modal.Header closeButton>
                    <Modal.Title>Create Whitelist Address</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <table className="table table-borderless">
                        <tbody>
                            <tr>
                                <td width="25%">
                                    Street Address 1:
                                </td>
                                <td>
                                    <input type="text" name="street_address_1" className="form-control" required />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Street Address 2:
                                </td>
                                <td>
                                    <input type="text" name="street_address_2" className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    City:
                                </td>
                                <td>
                                    <input type="text" name="city" className="form-control w-75" required />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Country:
                                </td>
                                <td>
                                    <select name="country" className="form-control w-75" onChange={(e) => { setCountry(e.target.value) }} required>
                                        <option value=""></option>
                                        <Countries />
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    State:
                                </td>
                                <td>
                                    {country === 'US' || country === 'CA' ?
                                        <select className="form-control w-75" name="state" onChange={(e) => { setState(e.target.value) }}>
                                            <option value=""></option>
                                            <States />
                                        </select> :

                                        <input type="text" name="state" className="form-control w-75" />
                                    }

                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Zip Code:
                                </td>
                                <td>
                                    <input type="text" name="zip_code" className="form-control w-75" />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Payment Platform:
                                </td>
                                <td>
                                    <select name="payment_platform" className="form-control w-75" required>
                                        <option value=""></option>
                                        <option value="TIPLATI">Tipalti</option>
                                        <option value="PAYONEER">Payoneer</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Purpose:
                                </td>
                                <td>
                                    <textarea type="text" name="purpose" className="form-control" maxLength={200}/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-sm btn-primary">Create</button>
                </Modal.Footer>
            </form>
        </Modal>
    )

}

export default WhitelistAddressModal